import React, { useState } from "react";
import "./BrandSetting.css";

export default function BrandSetting() {
  const [smallLogo, setSmallLogo] = useState(null);
  const [mainLogo, setMainLogo] = useState(null);

  const handleSmallLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) setSmallLogo(URL.createObjectURL(file));
  };

  const handleMainLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) setMainLogo(URL.createObjectURL(file));
  };

  return (
    <div className="brand-setting-page">
      {/* Page Title + Breadcrumb */}
      <div className="page-header">
        <h2>CRM Logo Settings</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / <a href="/app-settings">App Settings</a> / CRM Logo Settings
        </div>
      </div>

      {/* Card */}
      <div className="card">
        <h3>Update Brand Setting</h3>

        <div className="form-grid">
          {/* Small Logo */}
          <div className="form-group">
            <label>
              <strong>Logo</strong> <span>(58px x 58px)</span>
            </label>
            {smallLogo && <img src={smallLogo} alt="Small Logo Preview" className="logo-preview" />}
            <div className="file-input">
              <input
                type="file"
                id="smallLogo"
                accept="image/*"
                onChange={handleSmallLogoChange}
              />
              <label htmlFor="smallLogo">Choose Small Logo</label>
              <button type="button" className="browse-btn">Browse</button>
            </div>
          </div>

          {/* Main Logo */}
          <div className="form-group">
            <label>
              <strong>Logo</strong> <span>(Horizontal Logo)</span>
            </label>
            {mainLogo && <img src={mainLogo} alt="Main Logo Preview" className="logo-preview" />}
            <div className="file-input">
              <input
                type="file"
                id="mainLogo"
                accept="image/*"
                onChange={handleMainLogoChange}
              />
              <label htmlFor="mainLogo">Choose Logo</label>
              <button type="button" className="browse-btn">Browse</button>
            </div>
          </div>
        </div>

        {/* Update Button */}
        <div className="form-actions">
          <button className="update-btn">Update</button>
        </div>
      </div>

      {/* Footer */}
      <div className="footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </div>
    </div>
  );
}
